import property from 'lodash/property';
import { createSelector } from 'reselect';

import getParent from '../selectors';

export const getRightPane = state => getParent(state).rightPane;

export const getActiveChartsAndGraphsTab = createSelector(
  getRightPane, property('activeChartsAndGraphsTab')
);

export const getBinWidth = createSelector(
  getRightPane, property('binWidth')
);

export const getMinBinWidth = createSelector(
  getRightPane, property('minBinWidth')
);

export const getStartingPoint = createSelector(
  getRightPane, property('startPoint')
);

export const getMinStartingPoint = createSelector(
  getRightPane, property('minStartPoint')
);
